<template>
    <Card :padding="20" shadow>
        <i-form :model="dados_ticket" :rules="rules_validate" label-position="top" ref="ticket">
            <div class="title">
                <h4>{{ nome_ticket }}</h4>
                <h6>{{nome_projeto}}</h6>
            </div>
            <Row :gutter="16">
                <i-col :md="8" :sm="8" :xs="12">
                    <form-item label="Sistema" prop="sistema_id">
                        <i-select size="large" v-model="dados_ticket.sistema_id">
                            <i-option :key="sistema.value" :value="sistema.value" v-for="sistema in sistemas">{{
                                sistema.label }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col :md="8" :sm="8" :xs="12">
                    <form-item label="Tipo de Ticket" prop="tipo_id">
                        <i-select :disabled="dados_ticket.tipo_id == 45" size="large" v-model="dados_ticket.tipo_id">
                            <i-option :key="tipo.value" :value="tipo.value" v-for="tipo in tiposTickets">
                                {{ tipo.label }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col :md="8" :sm="8" :xs="12">
                    <form-item label="Relatado por" prop="relatado_por_id">
                        <i-select size="large" v-model="dados_ticket.relatado_por_id">
                            <i-option :key="pessoa.value"
                                      :value="pessoa.value"
                                      v-for="pessoa in pessoas">{{ pessoa.label }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
            </Row>
            <form-item label="Resumo do Ticket" prop="resumo">
                <TypeAhead :delayTime="500"
                           :fetch="getTickets"
                           :getResponse="(response) => response.data.data"
                           :highlighting="(item, vue) => item.resumo ? item.resumo.replace(vue.query, `<b>${vue.query}</b>`) : '' "
                           :limit="100"
                           :minChars="3"
                           :onHit="onSelectTypeahead"
                           :render="renderTypeahead"
                           queryParamName=":keyword"
                           src=":keyword"
                           v-if="!dados_ticket.id_ticket"
                           v-model="dados_ticket.resumo"
                ></TypeAhead>
                <i-input placeholder="Resumo do ticket..." size="large" v-else v-model="dados_ticket.resumo"></i-input>
            </form-item>
            <Row :gutter="16">
                <i-col :md="8" :sm="12" :xs="12" v-if="dados_ticket.modulo_id">
                    <form-item label="Módulo">
                        <i-select clearable size="large" v-model="dados_ticket.modulo_id">
                            <i-option :key="modulo.value"
                                      :value="modulo.value"
                                      v-for="modulo in modulos">{{ modulo.label }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col :md="8" :sm="9" :xs="20" v-if="dados_ticket.sintoma_id">
                    <form-item label="Sintoma" prop="sintoma_id">
                        <i-select clearable size="large" v-model="dados_ticket.sintoma_id">
                            <i-option :key="sintoma.value"
                                      :value="sintoma.value"
                                      v-for="sintoma in sintomas">{{ sintoma.label }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col :md="8" :sm="12" :xs="12" v-if="showModules && !dados_ticket.modulo_id">
                    <form-item label="Módulo" prop="modulo">
                        <i-select clearable size="large" v-model="dados_ticket.modulo">
                            <i-option :key="item.value"
                                      :value="item.value"
                                      v-for="item in tree.modules">{{ item.label }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                   <i-col :md="8" :sm="12" :xs="12" v-if="showSelectSs">
                    <form-item label="Categorias" prop="categoria">
                        <i-select clearable size="large" v-model="dados_ticket.ss_category_id">
                            <i-option :key="ss_category_id.value"
                                      :value="ss_category_id.value"
                                      v-for="ss_category_id in ss_category_id">{{ ss_category_id.label }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col :md="8" :sm="12" :xs="12" v-if="tree.functions.length">
                    <form-item label="Função" prop="funcao">
                        <i-select clearable size="large" v-model="dados_ticket.funcao">
                            <i-option :key="item.value"
                                      :value="item.value"
                                      v-for="item in tree.functions">{{ item.label }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col :md="8" :sm="12" :xs="12" v-if="tree.functionalities.length">
                    <form-item label="Funcionalidade" prop="funcionalidade">
                        <i-select clearable size="large" v-model="dados_ticket.funcionalidade">
                            <i-option :key="item.value"
                                      :value="item.value"
                                      v-for="item in tree.functionalities">{{ item.label }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col :md="8" :sm="3" :xs="4">
                    <form-item label="Movidesk" prop="movidesk_id">
                        <i-input size="large" v-model="dados_ticket.movidesk_id"></i-input>
                    </form-item>
                </i-col>
                <i-col :md="8" :sm="3" :xs="4" v-if="dados_ticket.id_ticket && !$route.path.includes('tickets/novo')">
                    <form-item label="Mal Descrito">
                        <i-switch :false-value='0' :true-value='1' size="large"
                                  :disabled="dados_ticket.atribuido_a_id !== this.idUser"
                                  v-model="dados_ticket.mal_descrito">
                            <Icon slot="open" type="md-checkmark"></Icon>
                            <Icon slot="close" type="md-close"></Icon>
                        </i-switch>
                    </form-item>
                </i-col>
            </Row>
            <form-item label="Causas do Bug" v-if="dados_ticket.id_ticket && dados_ticket.tipo_id == 32">
                <multiselect
                        :custom-label="(option) => option.descricao"
                        :max-height="150"
                        :multiple="true"
                        :options="causas_bug"
                        deselectLabel=" "
                        placeholder=" "
                        selectLabel=" "
                        selectedLabel=" "
                        track-by="descricao"
                        v-model="dados_ticket.causa_bug"
                        disabled
                />
            </form-item>
            <form-item :label="dados_ticket.tipo_id != 45 ? 'Descrição Detalhada' : 'Descrição'" prop="descricao">
                <vue-editor :editorToolbar="custom_toolbar" v-model="dados_ticket.descricao"></vue-editor>
            </form-item>
            <form-item style="marginBottom:0;marginTop:24px" v-if="dados_ticket.tipo_id != 45">
                <div :key="img_idx" class="lista-imagens" v-for="(imagem, img_idx) in dados_ticket.imagens.lista">
                    <img :src="imagem.fileUrl">
                    <div class="lista-imagens-cover">
                        <Icon @click.native="visualizarImagem(imagem.fileUrl)" type="ios-eye-outline"></Icon>
                        <Icon @click.native="removerImagem('imagens', img_idx)" type="ios-trash-outline"></Icon>
                    </div>
                </div>
                <vue2-dropzone :id="'dropzone-imagens'" :options="{
                  url: url_upload,
                  paramName: 'upload[]',
                  thumbnailWidth: 150,
                  maxFilesize: 0.5
              }" :useCustomSlot=true class="dropzone-imagens"
                               ref="imagens"
                               v-on:vdropzone-success="listarImagens('imagens')">
                    <Icon size="20" type="ios-camera"></Icon>
                </vue2-dropzone>
            </form-item>
            <form-item label="Tickets Associados" v-if="dados_ticket.associacoes.length > 0">
                <Card dis-hover>
                    <div :key="key" v-for="(associado, key) in dados_ticket.associacoes">
                        <div><b>Associado ao Ticket {{associado.id_ticket}}:</b> {{associado.resumo}}</div>
                        <div v-html="associado.descricao"></div>
                        <div v-html="associado.descricao_tela_ux"></div>
                    </div>
                </Card>
            </form-item>
            <Row :gutter="16" v-if="dados_ticket.tipo_id !== 45">
                <i-col :md="22" :sm="21" :xs="20">
                    <form-item :disabled="ticket_interno" label="Solicitantes" prop="solicitantes">
                        <multiselect
                                :custom-label="(option) => option.nome_empresa"
                                :disabled="ticket_interno"
                                :max-height="150"
                                :multiple="true"
                                :options="empresas"
                                deselectLabel=" "
                                placeholder=" "
                                selectLabel=" "
                                selectedLabel=" "
                                track-by="nome_empresa"
                                v-model="dados_ticket.solicitantes"
                        />
                    </form-item>
                </i-col>
                <i-col :md="2" :sm="3" :xs="4">
                    <form-item label="Interno" v-if="!(!permissoes.lancarInterno() && dados_ticket.id_ticket==0)">
                        <i-switch size="large" v-model="ticket_interno">
                            <Icon slot="open" type="md-checkmark"></Icon>
                            <Icon slot="close" type="md-close"></Icon>
                        </i-switch>
                    </form-item>
                </i-col>
            </Row>
        </i-form>
        <div class="floating-btn" v-show="ativar_botao_novo">
            <i-button @click="clearForm" icon="md-add" shape="circle" type="success"></i-button>
        </div>
        <div class="floating-btn" v-show="ativar_botao_salvar">
            <i-button @click="validar('ticket')" icon="md-checkmark" shape="circle" type="primary"></i-button>
        </div>
        <Modal footer-hide v-model="ver_imagem" width="1024">
            <img :src="url_imagem" style="width: 100%" v-if="ver_imagem">
        </Modal>
    </Card>
</template>

<script>
    import "vue-multiselect/dist/vue-multiselect.min.css";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import {mapGetters} from "vuex";

    const {editorToolbar} = require("../../helpers/utils.js");
    const _ = require("lodash");

    export default {
        components: {
            Multiselect: () => import("vue-multiselect"),
            vue2Dropzone: () => import("vue2-dropzone"),
            TypeAhead: () => import("vue2-typeahead"),
            VueEditor: () =>
                import("vue2-editor").then(({VueEditor}) => VueEditor)
        },
        name: "ticket",
        props: {
            id: Number,
            id_projeto: Number,
        },
        data() {
            /**
             * Custom validator de selects, pois o do iView não funciona como esperado
             */
            const validatorSelect = (rule, value, callback) => {
                if (value === 0) {
                    callback(new Error(rule.message));
                } else {
                    callback();
                }
            };
            /**
             * Valida se foi escolhido os solicitantes do Ticket, caso não seja um ticket interno
             */
            const validatorMultiSelect = (rule, value, callback) => {
                if (value.length === 0 && !this.ticket_interno) {
                    callback(new Error(rule.message));
                } else {
                    callback();
                }
            };
            return {
                url_upload: `${process.env.VUE_APP_API_URL}media/image`,
                url_imagem: "",
                ver_imagem: false,
                nome_ticket: "Novo ticket",
                nome_projeto: '',
                ativar_botao_salvar: false,
                ativar_botao_novo: false,
                ticket_interno: false,
                tip: [2, 3, 5, 8, 13, 21, 34, 55],
                tags: [
                    {
                        label:''
                    }
                ],
                dados_ticket: {
                    tela_ux: 0,
                    id_ticket: 0,
                    poker_time: 1,
                    tipo_id: 0,
                    sistema_id: 4,
                    relatado_por_id: 0,
                    sintoma_id: 0,
                    modulo_id: 0,
                    resumo: "",
                    descricao: "",
                    sub_tasks:"",
                    criterios_aceite:"",
                    solicitantes: [],
                    associacoes: [],
                    horas_desenvolvimento: 1,
                    movidesk_id: '',
                    imagens: {
                        lista: [],
                        salvas: [],
                        enviadas: [],
                        removidas: []
                    },
                    imagens_tela: {
                        lista: [],
                        salvas: [],
                        enviadas: [],
                        removidas: []
                    },
                    modulo: 0,
                    funcao: 0,
                    funcionalidade: 0,
                },
                rules_validate: {
                    sistema_id: [
                        {
                            required: true,
                            validator: validatorSelect,
                            message: "Informe o sistema",
                            trigger: "change"
                        }
                    ],
                    tipo_id: [
                        {
                            required: true,
                            validator: validatorSelect,
                            message: "Informe o tipo do Ticket",
                            trigger: "change"
                        }
                    ],
                    relatado_por_id: [
                        {
                            required: true,
                            validator: validatorSelect,
                            message: "Informe quem relatou",
                            trigger: "change"
                        }
                    ],
                    sintoma_id: [
                        {
                            required: true,
                            validator: validatorSelect,
                            message: "Informe o sintoma",
                            trigger: "change"
                        }
                    ],
                    resumo: [
                        {
                            required: true,
                            message: "Forneça um resumo simples",
                            trigger: "blur"
                        }
                    ],
                    descricao: [
                        {
                            required: true,
                            message: "Faça uma descrição detalhada do ticket",
                            trigger: "blur"
                        }
                    ],
                    solicitantes: [
                        {
                            required: true,
                            validator: validatorMultiSelect,
                            message: "Informe os solicitantes do ticket",
                            trigger: "change"
                        }
                    ],
                    funcao: [
                        {
                            required: true,
                            validator: validatorSelect,
                            message: "Informe a função",
                            trigger: "change"
                        }
                    ],
                    funcionalidade: [
                        {
                            required: true,
                            validator: validatorSelect,
                            message: "Informe a funcionalidade",
                            trigger: "change"
                        }
                    ],
                },
                sistemas: [],
                tipos: [],
                empresas: [],
                modulos: [],
                ss_category_id:[],
                sintomas: [],
                causas_bug: [],
                input_width: "100%",
                custom_toolbar: editorToolbar,
                tree: {
                    modules: [],
                    functions: [],
                    functionalities: [],
                }
            };
        },
        computed: {
            ...mapGetters(['usuariosAtivos', 'idUser', 'roleUser']),
            /**
             * Não permite selecionar um tipo de ticket de MVP,
             * só aparece selecionado se já vier previamente cadastrado (tela de projetos)
             */
            tiposTickets() {
                return this.tipos.filter(item => {
                    if (this.dados_ticket.tipo_id != 45) {
                        /**
                         *  Sistema (se 1.1 = bug, então Sistema só poder ser Bitis/Revenda/Matriz/Contador)
                         **/
                        if (![3, 4, 5, 31, 34, 39, 41, 51, 52].includes(this.dados_ticket.sistema_id)) {
                            return item.value != 32 && item.value != 45;
                        }
                        return item.value != 45;
                    }
                    return item.value != 0;
                }, this);
            },
            permissoes() {
                return {
                    lancarInterno: () => {
                        /**
                         * Permissão: Administração, Programadores e Testers
                         */
                        return [1, 4, 5, 6, 7, 8, 9, 29, 34].includes(this.roleUser);
                    },
                    tempoDes: () => {
                        /**
                         * Permissão: Administração
                         */
                        return [1, 29, 34].includes(this.roleUser);
                    },
                    fechar: () => {
                        /**
                         * Permissão: Administração e Testers
                         */
                        return [1, 29, 34].includes(this.roleUser);
                    }
                }
            },
            showSelectSs() {
                return [35].includes(this.dados_ticket.tipo_id);
            },
            showModules() {
                return [2, 3, 4, 31, 52].includes(this.dados_ticket.sistema_id)
                    && [32, 33, 45].includes(this.dados_ticket.tipo_id);
            },
            pessoas() {
                return _.orderBy(this.usuariosAtivos.map(item => ({
                    value: item.id_pessoa,
                    label: item.nome
                })), ['label'], ['asc']);
            }
        },
        methods: {
            /**
             * Obtém os tickets já cadastrados, quando está cadastrando um novo ticket
             * Caso já exista um ticket similar cadastrado, edita este ticket (escolha do usuário)
             */
            async getTickets(query) {
                const sistema = this.dados_ticket.sistema_id;
                const tipo = this.dados_ticket.tipo_id;
                const URI = `ticket?query=${query}&sistema_id=${sistema}&tipo_id=${tipo}&page=1`;
                return this.$axios.get(URI);
            },
            renderTypeahead(items, vue) {
                let newItem = [vue.query, ...items];
                return newItem;
            },
            async onSelectTypeahead(item, vue, index) {
                vue.query = item.resumo;
                if (item.id_ticket) {
                    await this.getTicket(item.id_ticket);
                    this.dados_ticket.reabrir = true;
                }
            },
            /**
             * Preenche alguns atributos necessários no BD
             * Ex: sistema_id, atualiza o sistema_nome ...
             */
            montarDados(dados_ticket) {
                let data = Object.assign({}, dados_ticket);
                if (data.sistema_id) {
                    data.sistema_nome = _.find(
                        this.sistemas,
                        o => o.value == data.sistema_id
                    ).label;
                } else {
                    delete data.sistema_id;
                }

                if (data.tipo_id) {
                    data.tipo_nome = _.find(
                        this.tipos,
                        o => o.value == data.tipo_id
                    ).label;
                } else {
                    delete data.tipo_id;
                }

                if (data.relatado_por_id) {
                    data.relatado_por_nome = _.find(
                        this.pessoas,
                        o => o.value == data.relatado_por_id
                    ).label;
                } else {
                    delete data.relatado_por_id;
                }

                if (data.modulo_id) {
                    data.modulo_nome = _.find(
                        this.modulos,
                        o => o.value == data.modulo_id
                    ).label;
                } else {
                    delete data.modulo_id;
                }

                if (data.sintoma_id) {
                    data.sintoma_nome = _.find(
                        this.sintomas,
                        o => o.value == data.sintoma_id
                    ).label;
                } else {
                    delete data.sintoma_id;
                }
                delete data.atribuido_a_id;

                return data;
            },
            /**
             * Antes de Salvar valida os dados dos inputs
             */
            validar(name) {
                this.$refs[name].validate(valid => {
                    if (!valid) {
                        this.$Message.error("Há campos não informados!");
                    } else {
                        this.salvar();
                    }
                });
            },
            /**
             * Atualiza um cadastro existente, ou cria um novo
             */
            async salvar() {
                const dados_ticket = this.montarDados(this.dados_ticket);

                try {
                    const id_ticket = this.dados_ticket.id_ticket;
                    const URI = `ticket`;
                    if (id_ticket == 0) {
                        /**
                         * Cria um novo ticket
                         */
                        let {data: {ticket}} = await this.$axios.post(
                            URI,
                            dados_ticket
                        );
                        this.atualizarDadosTickets(ticket);

                        this.$nextTick(() => {
                            this.ativar_botao_novo = true
                        })

                    } else {
                        /**
                         * Edita o ticket
                         */
                        let {data: {ticket}} = await this.$axios.put(
                            `${URI}/${id_ticket}`,
                            dados_ticket
                        );
                        this.atualizarDadosTickets(ticket);
                        
                        this.$nextTick(() => {
                            this.ativar_botao_novo = true
                        })
                    }
                    /**
                     * Após salvar, tenho que atualizar a lista de imagens,
                     * pois não está mais em uma pasta temporária
                     */
                    this.atualizarListaImagens("imagens");
                    this.$Message.success("ticket salvo com sucesso!");
                    setTimeout(() => {
                        this.ativar_botao_salvar = false;
                    }, 100);
                    this.$Spin.hide();
                } catch ({message}) {
                    console.warn(message);
                    this.$Message.error(`Erro! ${message}`);
                    this.$Spin.hide();
                }
            },
            getParams() {
                try {
                    this.getCausasBug();
                    this.getModulos();
                    this.getTiposTicket();
                    this.getSistemas();
                    this.getSintomas();
                    this.getEmpresas();
                    this.getTreeModules();
                    this.getSsCategory();
                } catch (error) {
                    console.warn(error);
                }
            },
            /**
             * Obtém os clientes da Exclaim,
             * para preenchimento dos Solicitantes
             */
            async getEmpresas() {
                const URI = `pessoa/empresas`;
                const {data} = await this.$axios.get(URI);

                this.empresas = data;
            },
             async getSsCategory() {
                const URI = `category/getCategory`;
                const {data} = await this.$axios.get(URI);
                this.ss_category_id = data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
            },
            async getModulos() {
                const URI = `parametro/modulos`;
                const {data} = await this.$axios.get(URI);

                this.modulos = data.map(item => ({
                    value: item.id_parametro,
                    label: item.descricao
                }));
            },
            async getTiposTicket() {
                const URI = `parametro/tiposTicket`;
                const {data} = await this.$axios.get(URI);

                this.tipos = data.map(item => ({
                    value: item.id_parametro,
                    label: item.descricao
                }));
            },
            async getSintomas() {
                const URI = `parametro/sintomas`;
                const {data} = await this.$axios.get(URI);

                this.sintomas = data.map(item => ({
                    value: item.id_parametro,
                    label: item.descricao
                }));
            },
            async getCausasBug() {
                const URI = `parametro/causasBug`;
                const {data} = await this.$axios.get(URI);

                this.causas_bug = data;
            },
            async getSistemas() {
                const URI = `parametro/sistemas`;
                const {data} = await this.$axios.get(URI);

                this.sistemas = data.map(item => ({
                    value: item.id_parametro,
                    label: item.descricao
                }));
            },
            async getChildren(id) {
                if (!id) return [];
                const {data: children} = await this.$axios.get(`tree/${id}/children`);
                return children.map(item => ({
                    value: item.id,
                    label: item.nome
                }));
            },
            async getTreeModules() {
                let modulos = await this.getChildren(1)
                this.tree.modules = _.orderBy(modulos, ['label'],['asc'])
            },
            async getTreeFunctions(id) {
                let funcao = await this.getChildren(id);
                this.tree.functions = _.orderBy(funcao, ['label'],['asc'])
                if (this.dados_ticket.funcao
                    && !Array.from(this.tree.functions).map(item => item.value).includes(this.dados_ticket.funcao)) {
                    this.dados_ticket.funcao = 0;
                    this.tree.functionalities = [];
                    this.dados_ticket.funcionalidade = 0;
                } else {
                    this.getTreeFunctionalities(this.dados_ticket.funcao);
                }
            },
            async getTreeFunctionalities(id) {
                let funcionalidade = await this.getChildren(id);
                this.tree.functionalities = _.orderBy(funcionalidade, ['label'],['asc'])
                if (this.dados_ticket.funcionalidade
                    && !Array.from(this.tree.functionalities).map(item => item.value).includes(this.dados_ticket.funcionalidade)) {
                    this.dados_ticket.funcionalidade = 0;
                }
            },
            /**
             * Busca os dados do ticket para edição
             */
            async getTicket(id_ticket) {
                try {
                    const URI = `ticket/${id_ticket}`;
                    const {data} = await this.$axios.get(URI);
                    this.nome_ticket = `Ticket ${data.id_ticket}`;
                    this.nome_projeto = data.projeto_nome;

                    this.atualizarDadosTickets(data);

                    this.ticket_interno =
                        this.dados_ticket.solicitantes.length === 0;

                    setTimeout(() => {
                        this.ativar_botao_salvar = false;
                    }, 100);
                    this.$Spin.hide();
                } catch (error) {
                    console.warn(error);
                    this.$Spin.hide();
                }
            },
            atualizarDadosTickets(ticket) {
                this.nome_ticket = `Ticket ${ticket.id_ticket}`;
                this.dados_ticket.id_ticket = ticket.id_ticket;
                this.dados_ticket.posicao = ticket.posicao;
                this.$emit('update', ticket);
                const {
                        id_ticket,
                        tipo_id,
                        sistema_id,
                        poker_time,
                        relatado_por_id,
                        sintoma_id,
                        modulo_id,
                        resumo,
                        descricao,
                        sub_tasks,
                        criterios_aceite,
                        tela_ux,
                        descricao_tela_ux,
                        mal_descrito,
                        atribuido_a_id,
                        horas_desenvolvimento,
                        anexos,
                        tela_ux_anexos,
                        solicitantes,
                        associacoes,
                        causa_bug,
                        movidesk_id,
                        modulo,
                        funcao,
                        ss_category_id,
                        funcionalidade
                    } = ticket;
                this.dados_ticket = {
                        id_ticket,
                        tipo_id,
                        sistema_id,
                        poker_time,
                        relatado_por_id,
                        sintoma_id,
                        modulo_id,
                        resumo,
                        descricao,
                        sub_tasks,
                        criterios_aceite,
                        tela_ux,
                        descricao_tela_ux,
                        movidesk_id,
                        mal_descrito: parseInt(mal_descrito) || 0,
                        modulo,
                        funcao,
                        funcionalidade,
                        atribuido_a_id,
                        horas_desenvolvimento: parseInt(horas_desenvolvimento) || 0,
                        solicitantes: solicitantes ? JSON.parse(solicitantes) : [],
                        associacoes: associacoes ? JSON.parse(associacoes) : [],
                        ss_category_id,
                        causa_bug,
                        imagens: {
                            lista: anexos ? JSON.parse(anexos) : [],
                            salvas: anexos ? JSON.parse(anexos) : [],
                            enviadas: [],
                            removidas: []
                        },
                        imagens_tela: {
                            lista: tela_ux_anexos ? JSON.parse(tela_ux_anexos) : [],
                            salvas: tela_ux_anexos
                                ? JSON.parse(tela_ux_anexos)
                                : [],
                            enviadas: [],
                            removidas: []
                        }
                    };
            },
            /**
             * Após salvar as imagens no servidor
             * Remove as imagens enviadas do dropzone
             */
            atualizarListaImagens(ref) {
                if (this.$refs[ref]) {
                    this.$refs[ref].removeAllFiles();
                }
            },
            /**
             * Upload de imagens de MVP
             * lista: Todas as imagens para visualização no loop de imagens no DOM
             * salvas: imagens já salvas no Banco de Dados
             * enviadas: imagens upadas em uma pasta temporária
             * removidas: imagens a serem removidas do servidor, quando clicar em salvar
             */
            listarImagens(ref) {
                /**
                 * Este loop obtem todas as imagens que foram enviadas e armazena no vetor imagens enviadas
                 * para ser salva no banco de dados
                 */
                const {dropzone} = this.$refs[ref];
                const imagens_enviadas = dropzone.files.map((arq, temp_idx) => {
                    if (arq.xhr && arq.xhr.response) {
                        const response = JSON.parse(arq.xhr.response);
                        if (response.files) {
                            let [arquivo] = response.files;
                            arquivo.temp = true;
                            arquivo.temp_idx = temp_idx;
                            return arquivo;
                        }
                    }
                }).filter(Boolean);

                const imagens_salvas = this.dados_ticket[ref].salvas;
                this.dados_ticket[ref].enviadas = imagens_enviadas;
                /**
                 * Concatena as imagens já salvas anteriormente com as que foram enviadas em um unico vetor para visualização
                 */
                this.dados_ticket[ref].lista = imagens_salvas.concat(
                    imagens_enviadas
                );
            },
            /**
             * Abre o Modal para visualização da imagem selecionada
             */
            visualizarImagem(url) {
                this.url_imagem = url;
                this.ver_imagem = true;
            },
            /**
             * Remove a imagem upada
             */
            removerImagem(ref, item_idx) {
                const imagem = this.dados_ticket[ref].lista[item_idx];
                if (imagem.temp) {
                    /**
                     * Caso ainda esteja na pasta temporária, apenas remove da lista
                     */
                    const arquivo = this.$refs[ref].dropzone.files[imagem.temp_idx];
                    this.$refs[ref].removeFile(arquivo);
                } else {
                    /**
                     * Caso já tenha sido upada anteriormente para o servidor,
                     * marca para remoção da imagem após salvar a edição
                     */
                    this.dados_ticket[ref].removidas.push(
                        this.dados_ticket[ref].salvas[item_idx]
                    );
                    this.dados_ticket[ref].salvas.splice(item_idx, 1);
                }
                this.listarImagens(ref);
            },

            clearForm(){
                this.url_upload = `${process.env.VUE_APP_API_URL}media/image`
                this.url_imagem = ""
                this.ver_imagem = false
                this.nome_ticket = "Novo ticket"
                this.nome_projeto = ''
                this.ativar_botao_salvar = false
                this.ticket_interno = false
                this.tip = [2, 3, 5, 8, 13, 21, 34, 55]
                this.dados_ticket = {
                    tela_ux: 0,
                    id_ticket: 0,
                    poker_time: 1,
                    tipo_id: 0,
                    sistema_id: 4,
                    relatado_por_id: parseInt(this.idUser) || 0,
                    sintoma_id: 0,
                    modulo_id: 0,
                    resumo: "",
                    descricao: "",
                    sub_tasks:"",
                    criterios_aceite:"",
                    solicitantes: [],
                    associacoes: [],
                    horas_desenvolvimento: 1,
                    movidesk_id: '',
                    imagens: {
                        lista: [],
                        salvas: [],
                        enviadas: [],
                        removidas: []
                    },
                    imagens_tela: {
                        lista: [],
                        salvas: [],
                        enviadas: [],
                        removidas: []
                    },
                    modulo: 0,
                    funcao: 0,
                    funcionalidade: 0,
                }
                this.input_width = "100%"
                this.custom_toolbar = editorToolbar
            }
        },
        created() {
            this.$Spin.show();
            this.getParams();
            if (this.id_projeto) {
                this.nome_ticket = "Novo MVP";
                this.dados_ticket.projeto_id = this.id_projeto;
                this.dados_ticket.tipo_id = 45;
            }
            /**
             * Ticket tenha um id nas props consulto os dados do ticket [edição];
             */
            if (this.id > 0) {
                this.getTicket(this.id);
            } else {
                this.dados_ticket.relatado_por_id = parseInt(this.idUser) || 0;
                setTimeout(() => {
                    this.ativar_botao_salvar = false;
                }, 100);
                this.$Spin.hide();
            }
        },
        watch: {
            /**
             * Observa alterações nos dados, para exibir o botão de salvar
             */
            dados_ticket: {
                handler() {
                    this.ativar_botao_salvar = true;
                    this.ativar_botao_novo = false;
                },
                deep: true
            },
            showModules(bol) {
                if (!bol) {
                    this.dados_ticket.modulo = 0;
                }
            },
            'dados_ticket.modulo'(val) {
                this.getTreeFunctions(val);
            },
            'dados_ticket.funcao'(val) {
                this.getTreeFunctionalities(val);
            }
        }
    };
</script>

<style>
    .dropdown-menu-list {
        border: 1px solid #e8e8e8;
        border-radius: 0 0 5px 5px;
        font-size: 16px;
        line-height: 32px;
    }

    .dropdown-menu-list a {
        color: #35495e;
    }

    .dropdown-menu-list li:hover {
        background-color: #2d8cf0 !important;
    }

    .dropdown-menu-list li:hover a {
        color: #fff !important;
    }
    .title{
        padding-bottom: 10px;
    }
    .title h4{
        padding-bottom: 5px;
    }
</style>
